import { setupI18n, type I18n, type Messages } from '@lingui/core';
import {
    getFormatLocale,
    type MessageLocale,
} from './locales';
import { getGeneratedCatalog } from './catalogs.generated';

export function getCatalog(locale: MessageLocale): Messages {
    const catalog = getGeneratedCatalog(locale);
    return { ...getGeneratedCatalog('en'), ...catalog };
}

export function activateLocale(
    i18n: I18n,
    locale: MessageLocale,
    formatLocale = getFormatLocale(locale)
): void {
    i18n.loadAndActivate({
        locale,
        locales: formatLocale,
        messages: getCatalog(locale),
    });
}

export function createAppI18n(locale: MessageLocale, formatLocale = getFormatLocale(locale)): I18n {
    const i18n = setupI18n();
    activateLocale(i18n, locale, formatLocale);
    return i18n;
}
